import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router";

import {
  EndorsementStatus,
  type PolicyWithAgencyDataFragment,
  type PolicyWithCheckReceivalDataFragment,
} from "@covertree/agent-portal-graphql";
import { useAppDispatch } from "@redux/hooks";
import {
  type EndorsementMode,
  EndorsementRoutes,
  navigateToEndorsementStep,
} from "@routing/paths";

export const FAILED_ISSUANCE_STATUSES: readonly EndorsementStatus[] = [
  EndorsementStatus.PaymentFailed,
  EndorsementStatus.IssuanceFailed,
  EndorsementStatus.ErrorOccurred,
];

export const useRedirectFailedEndorsement = (
  mode: EndorsementMode,
  policyLocator: string,
  endorsementId: string | null,
  policy?: PolicyWithAgencyDataFragment | PolicyWithCheckReceivalDataFragment
) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const status = useMemo(
    () =>
      policy?.endorsements?.find(
        (endorsement) => endorsement.endorsementLocator === endorsementId
      )?.status,
    [endorsementId, policy?.endorsements]
  );

  const isFailedIssuance =
    !!status && FAILED_ISSUANCE_STATUSES.includes(status);

  useEffect(() => {
    if (!isFailedIssuance || !endorsementId || mode === "issue") {
      return;
    }

    navigateToEndorsementStep(
      navigate,
      policyLocator,
      EndorsementRoutes.CHECKOUT,
      { dispatch, mode: "issue", endorsementId, replace: true }
    );
  }, [isFailedIssuance, mode, endorsementId, policyLocator]);
};
